import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { SidenavService } from '../services/sidenav.service';
import { GradeBoosterStore } from '../stores/grade-booster-store';

export const gradeBoosterGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const sidenavSvc = inject(SidenavService);
  const nav = router.currentNavigation();

  if (!inject(AuthenticationService).isUserLoggedIn()) {
    return router.parseUrl(
      '/login' + (nav?.finalUrl ? `?redirect=${nav.finalUrl.toString()}` : ''),
    );
  }

  if (inject(GradeBoosterStore).hasGradeBooster()) {
    return true;
  }

  sidenavSvc.naviagteToDashboard();
  return false;
};
